//#region 3rd
import {
  isEmpty,
  xor,
} from 'lodash';
//#endregion

export const sameArray = (a1: any[], a2: any[]): boolean => isEmpty(xor(a1, a2));
